module.exports = __webpack_public_path__ + "static/media/JP.f8dc0f04.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/JP.svg
// module id = 2181
// module chunks = 7